import { useState, useEffect } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { uiSound } from "@/lib/uiSound";

export default function SoundToggle({ iconClassName }) {
  const [muted, setMuted] = useState(uiSound.isMuted());
  useEffect(() => {
    const sync = () => setMuted(uiSound.isMuted());
    window.addEventListener("bhgc-sound-change", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("bhgc-sound-change", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  const toggle = () => {
    const next = uiSound.toggle();
    setMuted(next);
    if (!next) uiSound.play("nav");
  };
  return (
    <button onClick={toggle} title={muted ? "Activar sonidos" : "Silenciar sonidos"}
      className={`flex items-center p-1.5 ${iconClassName ?? "text-ink-muted"} hover:text-cyan transition-colors`}>
      {muted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
    </button>
  );
}